import moment from 'moment'
import { jwtDecode } from 'jwt-decode'

export const isTokenExpired = (date: moment.MomentInput): boolean => {
  return !moment(date).isAfter()
}

export const hasZid = (token: string | undefined | null): boolean => {
  if (!token) return false
  const decoded = jwtDecode(token)
  return decoded?.zid !== undefined
}
